"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var OverlayContext = /*#__PURE__*/(0, _react.createContext)();
OverlayContext.displayName = "OverlayContext";
var _default = OverlayContext;
exports.default = _default;